<template lang="pug">
	.asset-video-original-info(v-if="showed && asset" v-window)
		.card
			.card-header
				i.fa.fa-film
				span Original Asset Info
			.card-body.collapse.show
				.form-line.original.separator
					.videos(:class="{centered: true}")
						.video
							video(:src="originalAssetUrl" controls autoplay loop muted playsinline)
				.form-actions
					button.btn.btn-dark.right-button(type="button" @click="closeWindow()") Close
</template>

<script>

	import Screen 				from '../../mixins/screen'

	export default {
		name: "AssetVideoOriginalInfo",
		mixins: [Screen],
		screen: {
			updateOn: [

			],
			events: {
				"Show AssetVideoOriginalInfo": function(variation, asset) {

					this.variation = variation;
					this.asset = asset;
					this.originalAssetUrl = Asset.getAssetOriginalUrl(this.asset);

					this.creative = Creative.SelectedCreative;

					this.update();

				}
			}
		},
		data() {

			this.asset = null;
			this.originalAssetUrl = '';

			return {

			}

		},
		methods: {
			collectData() {

			}
		}
	}
</script>


<style lang="sass">

	.asset-video-original-info
		display: flex
		position: absolute
		z-index: 2000
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)
		transition: opacity 0.2s

		.separator
			padding-bottom: 20px
			border-bottom: 1px solid rgba(0, 0, 0, 0.3)
			margin-bottom: 10px

		.card
			width: 940px
			margin: auto
			display: flex
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)
			transition: 0.2s

			button
				white-space: nowrap
				margin-right: 20px

				i
					margin-right: 10px

			.btn-ghost-dark, .btn-dark
				color: #fff

			.card-header
				display: flex
				flex-direction: row

		.form-line
			display: flex
			flex-direction: row

		.original
			flex-direction: column
			padding-bottom: 7px

		.videos
			display: flex
			flex-direction: row
			padding: 10px

			&.centered
				justify-content: center

			.video
				position: relative
				display: flex
				justify-content: center

				video
					max-width: 100%
					max-height: 60vh
					border-radius: 5px
					border: 1px solid var(--gray-dark)
					box-shadow: 0px 0px 5px var(--gray-dark)
					background-color: #000

		.form-actions
			display: flex
			flex-direction: row
			align-items: center
			margin-top: 20px

			.right-button
				margin-left: auto

</style>
